import { ApiResponse, PaginatedResponse } from "../types/common";
import {
  PublicCourse,
  CreatePublicCourseRequest,
  UpdatePublicCourseRequest,
  PublicCourseFilter,
} from "../types/landing";
import api from "./api";

// Public Course CRUD Operations
export const publicCourseService = {
  getAllCourses: async (
    filters: PublicCourseFilter = {}
  ): Promise<PaginatedResponse<PublicCourse>> => {
    try {
      const params = new URLSearchParams();

      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.search) params.append("search", filters.search);
      if (filters.status) params.append("status", filters.status);
      if (filters.category) params.append("category", filters.category);
      if (filters.level) params.append("level", filters.level);

      const response = await api.get(
        `/landing/courses/admin?${params.toString()}`
      );

      const data = response as any;
      return {
        success: data.success,
        data: data.data || [],
        pagination: {
          currentPage: data.currentPage || 1,
          totalPages: data.totalPages || 1,
          totalItems: data.total || 0,
          hasNext: (data.currentPage || 1) < (data.totalPages || 1),
          hasPrev: (data.currentPage || 1) > 1,
        },
      };
    } catch (error) {
      console.error("Error fetching courses:", error);
      throw error;
    }
  },

  getCourseById: async (id: string): Promise<ApiResponse<PublicCourse>> => {
    try {
      const response = await api.get(`/landing/courses/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error fetching course by ID:", error);
      throw error;
    }
  },

  createCourse: async (
    courseData: CreatePublicCourseRequest
  ): Promise<ApiResponse<PublicCourse>> => {
    try {
      const response = await api.post("/landing/courses", courseData);
      return response as any;
    } catch (error) {
      console.error("Error creating course:", error);
      throw error;
    }
  },

  updateCourse: async (
    id: string,
    courseData: UpdatePublicCourseRequest
  ): Promise<ApiResponse<PublicCourse>> => {
    try {
      const response = await api.put(`/landing/courses/${id}`, courseData);
      return response as any;
    } catch (error) {
      console.error("Error updating course:", error);
      throw error;
    }
  },

  deleteCourse: async (id: string): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/landing/courses/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error deleting course:", error);
      throw error;
    }
  },

  activateCourse: async (id: string): Promise<ApiResponse<PublicCourse>> => {
    try {
      const response = await api.patch(`/landing/courses/${id}/activate`);
      return response as any;
    } catch (error) {
      console.error("Error activating course:", error);
      throw error;
    }
  },

  deactivateCourse: async (id: string): Promise<ApiResponse<PublicCourse>> => {
    try {
      const response = await api.patch(`/landing/courses/${id}/deactivate`);
      return response as any;
    } catch (error) {
      console.error("Error deactivating course:", error);
      throw error;
    }
  },

  updateCourseOrder: async (
    id: string,
    displayOrder: number
  ): Promise<ApiResponse<PublicCourse>> => {
    try {
      const response = await api.patch(`/landing/courses/${id}/order`, {
        displayOrder,
      });
      return response as any;
    } catch (error) {
      console.error("Error updating course order:", error);
      throw error;
    }
  },
};
